var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.getAlertType(_vm.vigenciaC3),"dense":"","color":_vm.getAlertColor(_vm.vigenciaC3)}},[_vm._v(" "+_vm._s(_vm.getAlertText(_vm.vigenciaC3))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }